import { Link } from "react-router-dom";

import { GlofoxBrandLogo } from "@/components/portal/GlofoxBrandLogo";
import { HomeTopNav } from "@/components/portal/HomeTopNav";
import { usePageTitle } from "@/hooks/usePageTitle";

/** Platform picker. Routed at `/` only when `hasMultiplePlatforms()` is true. */
export default function Home() {
  usePageTitle();
  return (
    <>
      <HomeTopNav />

      <main id="main-content">
      <div className="hero" data-testid="home-hero">
        <p className="hero-eye" data-testid="home-hero-eye">ABC Fitness Platform</p>
        <h1 data-testid="home-title">
          Build on the <span data-testid="home-title-highlight">fitness stack</span>
          <br />
          you already trust
        </h1>
        <p className="hero-sub" data-testid="home-hero-sub">
          Self-service developer access to the Glofox platform. Connect,
          integrate, and scale with production-grade APIs built for the fitness
          industry.
        </p>
      </div>

      <div className="portal-grid" data-testid="home-portal-grid">
        <Link
          className="portal-card"
          to="/glofox"
          data-testid="home-portal-glofox"
        >
          <div className="card-accent gf-accent" />
          <div className="card-body">
            <GlofoxBrandLogo to="" variant="card" testId="home-portal-glofox-logo" />
            <p className="card-desc">
              Gym &amp; studio management platform. Memberships, scheduling,
              payments, and member engagement APIs.
            </p>
            <div className="card-tags">
              <span className="tag gf-tag">Members API</span>
              <span className="tag gf-tag">Bookings</span>
              <span className="tag gf-tag">Payments</span>
              <span className="tag gf-tag">Webhooks</span>
            </div>
            <div className="cta gf-cta">Enter portal →</div>
          </div>
        </Link>
      </div>

      <div className="stats-bar" data-testid="home-stats-bar">
        <div className="stat-seg">
          <div className="num">1</div>
          <div className="lbl">Platform portal</div>
        </div>
        <div className="stat-seg">
          <div className="num">REST</div>
          <div className="lbl">Standards-based APIs</div>
        </div>
      </div>
      </main>
    </>
  );
}
